import { render } from "./SplitButton.vue?vue&type=template&id=4cb7a124&scoped=true"
import script from "./SplitButton.vue?vue&type=script&lang=js"
export * from "./SplitButton.vue?vue&type=script&lang=js"

import "./SplitButton.vue?vue&type=style&index=0&id=4cb7a124&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4cb7a124"

export default script